import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import { styles } from './pdfStyles';
import { utcToGmt } from '../../components/utils';
import { DateText, DocumentLabel, DocumentNumber } from '../../components';
import { InvoiceItems } from './InvoiceItems';
import { Receipt } from './Receipt';
import { PdfBalanceSheet } from './PdfBalanceSheet';

export const PdfInvoiceDetailed = ({ dataBilling = {} }) => {
  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <Text style={styles.h1}>Fatura</Text>
        <View style={styles.meta}>
          <View style={styles.column}>
              <Text style={styles.label}>Cliente</Text>
              <Text style={{...styles.text, marginBottom: 10}}>{dataBilling?.payerName}</Text>
              <Text style={styles.label}>Data de Vencimento</Text>
              <Text style={{...styles.text, marginBottom: 10}}>
                <DateText date={dataBilling.invoiceDueDate} />
              </Text>
              <Text style={styles.label}>
                <DocumentLabel number={dataBilling.payerDocumentNumber} />
              </Text>
              <Text style={{...styles.text, marginBottom: 10}}>
                <DocumentNumber number={dataBilling.payerDocumentNumber} />
              </Text>
              <Text style={styles.label}>Endereço</Text>
              <Text style={{...styles.text, marginBottom: 10}}>{dataBilling?.payerAddress}</Text>

              <Text style={styles.h2}>Detalhes da Fatura</Text>
              
              <Text style={styles.label}>Data da Emissão</Text>
              <Text style={{...styles.text, marginBottom: 10}}>
                <DateText date={utcToGmt(dataBilling.invoiceCreatedDate)} />
              </Text>
              <Text style={styles.label}>Identificador da Fatura</Text>
              <Text style={{...styles.text, marginBottom: 10}}>{dataBilling.invoiceIdentify}</Text>

              <InvoiceItems items={dataBilling.invoiceItems} />
          </View>

          <View style={styles.column}>
            <Text style={styles.h2}>Balancete Sintético</Text>
            <PdfBalanceSheet dataBilling={dataBilling} />
          </View>
        </View>

        <Receipt dataBilling={dataBilling} />
      </Page>
    </Document>
  );
};